import { SectionIRow } from '@/features/dashboard/tfg/types/TfgDeklaracjaPreviewDto.ts';
import DeklaracjaSectionTable from '@/features/dashboard/tfg/components/DeklaracjaSectionTable.tsx';

const formatInt = (value: number) => value.toLocaleString('pl-PL');

interface DeklaracjaSectionIProps {
  rows: SectionIRow[];
  /** Section I total — UFG field 60. */
  total: number;
}

const DeklaracjaSectionI = ({ rows, total }: DeklaracjaSectionIProps) => (
  <DeklaracjaSectionTable<SectionIRow>
    title="Dział I — Składka należna"
    subtitle="Składka z tytułu umów zawartych w okresie sprawozdawczym (pola 12–59, suma w polu 60)."
    rows={rows}
    getPkt={(row) => row.pkt}
    getTiming={(row) => row.paymentTiming}
    fieldNumberBase={12}
    makeEmptyRow={(pkt, paymentTiming) => ({
      pkt,
      paymentTiming,
      liczbaUmow: 0,
      liczbaPodroznych: 0,
      stawka: 0,
      skladka: 0,
    })}
    dataColumns={[
      {
        header: 'Liczba umów zawartych z podróżnymi',
        align: 'right',
        render: (row) => formatInt(row.liczbaUmow),
      },
      {
        header: 'Liczba podróżnych objętych umowami',
        align: 'right',
        render: (row) => formatInt(row.liczbaPodroznych),
      },
      {
        header: 'Wysokość składki należnej od każdego podróżnego na TFG (w zł)',
        align: 'right',
        render: (row) => formatInt(row.stawka),
      },
      {
        header: 'Łączna wysokość składki należnej na TFG (w zł)',
        align: 'right',
        render: (row) => formatInt(row.skladka),
      },
    ]}
    totalLabel="Razem składka (pole 60)"
    totalValue={formatInt(total)}
  />
);

export default DeklaracjaSectionI;
